module.exports = __webpack_public_path__ + "static/media/RearCamera.738e022a.svg";